import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ApplicationPermissionsWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-application-permissions.sass');

export class ApplicationPermissionsWidget extends WidgetBase {
    public static _name: string = 'Application Permissions';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-application-permissions';
    public static icon: string = 'time';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-application-permissions'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ApplicationPermissionsWidget);
